import './SettingsProperty.scss'

import React, {Component} from 'react';
import SettingsSelect from './SettingsSelect.js'

import { push } from 'react-router-redux'

import {
  PROPERTY_TYPE
} from 'common/constants'

const SettingsProperty = ({dispatch, settings, onSelect}) => {

  const defaultIndicator = <span className="SettingsSelect__additional SettingsSelect__additional--success">Default</span>

  const additionalMap = {
    "no-preference": defaultIndicator,
  }

  return (
    <div className="SettingsClient">
      <div className="Settings__label">Property Types</div>
      <SettingsSelect multiselect={true} options={PROPERTY_TYPE} rightAdditionalMap={additionalMap} selected={settings.property_categories} onClick={onSelect} />
    </div>
  )
}

export default SettingsProperty
